var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.4V5.6C6 5.44087 6.06321 5.28826 6.17574 5.17574C6.28826 5.06321 6.44087 5 6.6 5H9.4C9.55913 5 9.71174 5.06321 9.82426 5.17574C9.93679 5.28826 10 5.44087 10 5.6V18.4C10 18.5591 9.93679 18.7117 9.82426 18.8243C9.71174 18.9368 9.55913 19 9.4 19H6.6C6.44087 19 6.28826 18.9368 6.17574 18.8243C6.06321 18.7117 6 18.5591 6 18.4ZM14 18.4V5.6C14 5.44087 14.0632 5.28826 14.1757 5.17574C14.2883 5.06321 14.4409 5 14.6 5H17.4C17.5591 5 17.7117 5.06321 17.8243 5.17574C17.9368 5.28826 18 5.44087 18 5.6V18.4C18 18.5591 17.9368 18.7117 17.8243 18.8243C17.7117 18.9368 17.5591 19 17.4 19H14.6C14.4409 19 14.2883 18.9368 14.1757 18.8243C14.0632 18.7117 14 18.5591 14 18.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.1a0fdbe5276b64ebf66866312ee3d4fb.svg";
export { ForwardRef as ReactComponent };